
  const __registry__ = require('../../../../spiferack/client/index.js')
  'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var React = require('react');
var connect = require('../../../components/connect');
var ExpirationDaysInput = require('./expiration-days-input');
var formStyles = require('../../../../shared/styles/forms.css');
var gatStyles = require('../gat.css');
var Input = require('../../../components/inputs/semi-controlled');
var _require = require('./constants'),
  EXPIRATION_DATE_INPUT = _require.EXPIRATION_DATE_INPUT;
var MS_PER_DAY = 1000 * 60 * 60 * 24;
function GATExpiration(props) {
  var formId = props.formId,
    formData = props.formData,
    name = props.name,
    label = props.label,
    onInputChange = props.onInputChange,
    validateSingleInput = props.validateSingleInput;
  var _React$useState = React.useState('30'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expirationDays = _React$useState2[0],
    setExpirationDays = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    expirationDate = _React$useState4[0],
    setExpirationDate = _React$useState4[1];
  var onExpirationSelect = React.useCallback(function (expirationDays) {
    setExpirationDays(expirationDays);
    setExpirationDate('');
    onInputChange(name, expirationDays);
    props.dispatch({
      type: 'FORM_CHANGE',
      formId: formId,
      name: name,
      value: expirationDays
    });
  }, [expirationDays]);
  var onExpirationDateEntered = React.useCallback(function (date) {
    setExpirationDate(date);
    setExpirationDays('');
    var days = daysTillDate(date).toString();
    onInputChange(name, days);
    props.dispatch({
      type: 'FORM_CHANGE',
      formId: formId,
      name: name,
      value: days
    });
  }, [expirationDate]);
  var inputClassName = "".concat(gatStyles.inputExpirationDate, " ").concat(gatStyles.textInput);
  var labelId = "".concat(formId, "_expiration_section");
  var errorMessageId = "".concat(labelId, "_error_message");
  var errorMessage = formData[formId][name].errorMessage;
  var valid = !errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: gatStyles.inputContainer
  }, /*#__PURE__*/React.createElement("label", {
    id: labelId,
    className: gatStyles.inputLabel
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(ExpirationDaysInput, {
    formId: formId,
    onSelect: onExpirationSelect,
    outerLabelId: labelId,
    ariaDescribedby: errorMessageId
  }), expirationDays === '' && /*#__PURE__*/React.createElement(Input, {
    type: "date",
    name: EXPIRATION_DATE_INPUT,
    value: expirationDate,
    min: tomorrowDate(),
    className: "".concat(inputClassName, " ").concat(valid ? '' : formStyles.invalid, " "),
    onChange: function onChange(ev) {
      return onExpirationDateEntered(ev.target.value);
    },
    onBlur: function onBlur() {
      return validateSingleInput(name, formData);
    },
    "aria-labelledby": labelId,
    "aria-describedby": errorMessageId,
    "aria-invalid": !!errorMessage
  })), /*#__PURE__*/React.createElement("div", {
    className: formStyles.errorMessage,
    id: errorMessageId
  }, errorMessage));
}
function daysTillDate(date) {
  var now = new Date();
  var expirationDate = new Date(date);
  var diff = expirationDate.getTime() - now.getTime();
  return Math.ceil(diff / MS_PER_DAY);
}
function tomorrowDate() {
  var today = new Date();
  var tomorrow = new Date(today.getTime() + MS_PER_DAY);
  return tomorrow.toISOString().split('T')[0];
}
module.exports = connect()(GATExpiration);
  let __hot__
  
  __registry__.register('tokens/gat/gat-expiration', module.exports, __hot__)
  